import { Pipe, PipeTransform } from '@angular/core';
import { EFormsSurveySummary } from '../e-form-survey-summary.model';

@Pipe({
  name: 'surveyAnswerIsCritical'
})
export class SurveyAnswerIsCriticalPipe implements PipeTransform {

  transform(summary: EFormsSurveySummary, fieldID: number): boolean {
    let result = false;

    if (summary && summary.Answers) {
      const answer = summary.Answers.find(o => o.SurveyFieldID == fieldID);
      if (answer) {
        result = answer.IsCritical;
      }
    }

    return result;
  }

}
